import {createApp} from 'vue'
import App from './App.vue'
import {registerPlugins} from '@/plugins'

const app = createApp(App)

registerPlugins(app)

app.mount('#app')

const placeholder = document.querySelectorAll('.placeholder-app-logo')[0] as HTMLElement

setTimeout(() => {
    placeholder.style.display = 'none'
}, 1000)
